module.exports = __webpack_public_path__ + "static/media/pierlugi-bernasconi.246c73d1.jpeg";